import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  message: string = '';
  constructor(
    private router: Router,
    private location: Location
  ) { 
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;

    if (!!state) {
      this.message = state['message'];
    }
    else {
      // if no message in state, check query params
      const queryParams = this.router.parseUrl(this.router.url).queryParams;
      if (!!queryParams) {
        this.message = queryParams['message'] || '';
      }
    }
  }

  ngOnInit(): void {
  }

  goBack() {
    this.location.back();
  }

}
